import * as React from 'react'

import CanvasIntegrationForm from './canvasIntegrationForm'
import { School, CanvasInstance, } from './shared'
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';

interface CanvasIntegrationModalProps {
  schools: School[];
  success: () => void;
  existingIntegration?: CanvasInstance;
  close?: () => void;
}

const CanvasIntegrationModal = (props: CanvasIntegrationModalProps) => {
  const { modalRef } = useModalAccessibility(close);
  return (
    <div className="modal-container custom-date-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="canvasIntegrationModalTitle"
        aria-modal="true"
        className="canvas-integration-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <CanvasIntegrationForm {...props} />
      </div>
    </div>
  )
}

export default CanvasIntegrationModal
